import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ManagePracticeService } from '../../manage-practice.service';
import { CustomLoadingService } from 'src/app/shared/custom-loading/custom-loading.service';
import { AlertService } from 'src/app/shared/toast/alert.service';

@Component({
  selector: 'app-add-counselors',
  templateUrl: './add-counselors.component.html',
  styleUrls: ['./add-counselors.component.css']
})
export class AddCounselorsComponent implements OnInit {
  counselorForm: FormGroup
  licenses: any = [];
  counselor: any = []
  error: any
  title: any = "Counselor"
  constructor(

    private activatedRoute: ActivatedRoute,
    private alertService:AlertService,
    private translateService:TranslateService,
    private formBuilder: FormBuilder,
    private managePracticeService: ManagePracticeService,
    private loadingService: CustomLoadingService,
    private router: Router
  ) {

    this.counselorForm = this.formBuilder.group({
      CounselorId: [0],
      FirstName: ['', Validators.compose([Validators.required])],
      LastName: ['', Validators.compose([Validators.required])],
      Licenses: new FormArray([]),

    });
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {

      this.counselorForm.controls["CounselorId"].setValue(params["id"] || 0)

    })
    this.activatedRoute.data.subscribe((data: { counselor: any }) => {
      this.counselor = data.counselor;

      if (this.counselor) {
        this.counselorForm.controls["FirstName"].setValue(this.counselor.FirstName)
        this.counselorForm.controls["LastName"].setValue(this.counselor.LastName)
        this.licenses = this.counselor.LicenseList
        const formArray: FormArray = this.counselorForm.get('Licenses') as FormArray;

        this.licenses.forEach(element => {
          /* Selected */
          if (element.IsSelected) {
            // Add a new control in the arrayForm
            formArray.push(new FormControl(element.Id));
          }

        });
      }
    })
  }

onCheckChange(event) {
  const formArray: FormArray = this.counselorForm.get('Licenses') as FormArray;

  /* Selected */
  if (event.target.checked) {
    // Add a new control in the arrayForm
    formArray.push(new FormControl(event.target.value));
  }
  /* unselected */
  else {
    // find the unselected element
    let i: number = 0;

    formArray.controls.forEach((ctrl: FormControl) => {
      if (ctrl.value == event.target.value) {
        // Remove the unselected element from the arrayForm
        formArray.removeAt(i);
        return;
      }

      i++;
    });
  }
}
AddCounselor(model: any) {
  
  if (this.counselorForm.valid) {
    this.loadingService.show();
    this.managePracticeService.addCounselor(model).subscribe(res => {
      this.alertService.success(this.translateService.instant("RecordSaved"), { keepAfterRouteChange: true });
     
      this.router.navigate(["/managepractice/counselors"]);

    }, (error) => {

      this.alertService.error(this.translateService.instant("GenericError"), { keepAfterRouteChange: true });
     
    
      this.loadingService.hide();
    }, () => {
      this.loadingService.hide();
    })
  }
}

}
